import { MDBBtn, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle } from 'mdb-react-ui-kit'
import React from 'react'

function StreamsAPIWebHookURLAlert(props) {
    return (
            <>
                <MDBModal tabIndex="-1" open={props.open} onClose={() => props.setOpen(false)} >
                    <MDBModalDialog log>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>Alert - {props.alertHeader} Webhook URL</MDBModalTitle>
                                <MDBBtn className="btn-close" color="none" onClick={() => { props.setOpen(false) }}></MDBBtn>
                            </MDBModalHeader>
                        <MDBModalBody>
                            <b>WARNING! </b> 
                            The entered WebHook URL for {props.changedWebhooks?.join(", ")} will replace the existing URL(s) in all App(s).Are you sure you want to continue?
                        </MDBModalBody>
                            <MDBModalFooter>
                            <MDBBtn size="sm" color="secondary" onClick={() => {
                                props.cancelApiUrls()
                                props.setOpen(false)
                                props.onCloseChanges()
                            }} >
                                Cancel
                            </MDBBtn>
                            <MDBBtn size="sm" color="primary" onClick={() => {
                                props.saveButtonChanges()
                                props.setActionType(true)
                                props.setOpen(false)
                            }}>
                                Save
                            </MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>
            </>
        )
}

export default StreamsAPIWebHookURLAlert;